import { IUseGraphqlQueryOptions } from '@proscom/prostore-apollo-react';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { FeedbackPageInput, FeedbacksPageType } from '../../types';
import { ONE_PAGE_ITEMS } from '../../../constants';
import { QUERY_GET_FEEDBACK_PAGE } from '../../queries/feedback';

export interface UseEventsPageVars {
  input: FeedbackPageInput;
}

const queryOptions: IUseGraphqlQueryOptions<
  UseEventsPageVars,
  FeedbacksPageType
> = {
  query: QUERY_GET_FEEDBACK_PAGE,
  mapData: (result) => result.feedbacksPage
};

export function useFeedbackPage({ filter, pagination }: FeedbackPageInput) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: {
      input: {
        filter,
        pagination: {
          ...pagination,
          onePage: ONE_PAGE_ITEMS
        }
      }
    }
  });
}
